import React from "react";
import { MdChevronRight } from "react-icons/md";

export interface IRightNavProps {
  onClick: React.MouseEventHandler<HTMLElement>;
  disabled: boolean;
}

export const RightNav: React.FC<IRightNavProps> = ({ onClick, disabled }) => {
  return !disabled ? (
    <button
      onClick={onClick}
      className="image-gallery-icon image-gallery-right-nav text-7xl"
    >
      <MdChevronRight />
    </button>
  ) : (
    <></>
  );
};
